import styled from 'styled-components';
import Link from 'next/link';
import { Img } from '@/src/components/common/ui/images/Img';
import { devices, theme } from 'styles/theme';
import ReactHtmlParser from 'react-html-parser';

const BlogSingle = ({title, text, link, img, day, month, year}) => {
	return (
		<StyledBlogSingle className='blog-single'>
			<div className="blog-single__inner">
				<Link prefetch={true} href={link || '/blog/slug'}></Link>
				<Img src={img} objectFit={'cover'} alt={ReactHtmlParser(title)} layout={'fill'}/>
				<div className="blog-single__inner__content">
					<div className="blog-single__inner__content__top">
						<p>{text}</p>
						<h6>{title}</h6>
					</div>

					{
						day && month && year ?
							<div className="blog-single__inner__content__bottom">
								<h4>{day}</h4>
								<p>
									<span>{month} </span>
									<span>{year}</span>
								</p>
							</div>
							: ''
					}

				</div>
			</div>
		</StyledBlogSingle>
	);
};

const StyledBlogSingle = styled.div`


    .blog-single__inner {
        ${theme.blogImageRation}
        a {
            ${theme.absoluteFill}
            z-index: 3;
        }

        .global-image {
            &:after {
                ${theme.absoluteFillTop}
                background: ${theme.colors.imageTint};
                content: '';
            }
        }

        &__content {
            &:after {
                ${theme.absoluteFill}
                width: 100%;
                height: 100%;
                content: '';
                background: ${theme.colors.secondaryGreen70};
                transition: ${theme.transition};
            }

            &__top {
                p {
                    ${theme.mainFont}
                    color: ${theme.colors.white};
                    position: absolute;
                    left: 40px;
                    top: 40px;
                    right: 40px;
                    z-index: 2;
                    margin: 0;
                    transition: ${theme.transition};
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 5;
                    -webkit-box-orient: vertical;
                    opacity: 0;
                    transition-delay: 0.2s;

                }

                h6 {
                    position: absolute;
                    top: 40px;
                    left: 40px;
                    right: 40px;
                    z-index: 2;
                    color: ${theme.colors.white};
                    margin: 0;
                    transition: ${theme.transition};
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 5;
                    -webkit-box-orient: vertical;
                    ${theme.secondTitle}
                    transition-delay: 0.2s;

                }
            }

            &__bottom {
                position: absolute;
                margin: 0;
                left: 40px;
                right: 40px;
                bottom: 60px;
                display: flex;
                justify-content: space-between;
                border-top: 1px solid ${theme.colors.blogBorder};
                padding-top: 20px;
                z-index: 2;

                h4 {
                    font-weight: 600;
                    font-size: 2.25rem;
                    line-height: 1;
                    letter-spacing: -0.03em;
                    color: ${theme.colors.white};
                    transition: ${theme.transition};
                }

                p {
                    color: ${theme.colors.whiteBlog};
                    font-weight: 500;
                    font-size: 1.125rem;
                    line-height: 1;
                    letter-spacing: -0.03em;

                    span {
                        display: block;
                    }
                }

            }
        }

        &:hover {
            .blog-single__inner__content__top {

                h6 {
                    opacity: 0;
                }

                p {
                    transform: none;
                    opacity: 1;
                    color: ${theme.colors.white};
                }
            }

            .blog-single__inner__content__bottom {
                h4 {
                    color: ${theme.colors.white};
                }

                p {
                    color: ${theme.colors.white};

                    span {
                        color: ${theme.colors.white};
                    }
                }
            }
        }

    }

    &:hover {
        .blog-single__inner__content:after {
            height: 0;
        }
    }


    ${devices.sm} {
        .blog-single__inner__content__top {
            p, h2 {
                left: 30px;
                right: 30px;
                top: 30px;
            }
        }

        .blog-single__inner__content__bottom h4, .blog-single__inner__content__bottom p {
            left: 30px;
            right: 30px;
            top: 30px;
        }

    }

`;
export default BlogSingle;
